import React from "react";
import MarketSidebar from "components/Market/MarketSidebar/MarketSidebar";
import MarketTile from "components/Market/MarketTile/MarketTile";

import styles from "./style.module.css";

const MarketDatasets = (props) => {
  const { type, hideSearch } = props;

  const renderGridTiles = () => {
    const { datasets } = props;
    return (
      <div className={styles.gridTilesTable}>
        {datasets.map((data, index) => {
          return (
            <div key={index} className={styles.gridTilesTableColumn}>
              <MarketTile data={data} type={type} />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <React.Fragment>
      {hideSearch !== true && <MarketSidebar type={type} />}
      <div className={styles.boardMainContainer}>
        <div className={styles.mainContainerHeader}>Available Datasets</div>
        <div>{renderGridTiles()}</div>
      </div>
    </React.Fragment>
  );
};

export default MarketDatasets;
